module.exports = "/_next/static/images/Hero@2x-f376af8d94718a36777f153fb9d00453.webp";